import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface ApplicationUser {
  accessToken: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private currentUserSubject!: BehaviorSubject<any>;
  public currentUser!: Observable<any>;

  constructor(
    private readonly http: HttpClient,
    private readonly router: Router
  ) { }

  public get currentUserValue(): any {
    const userToken: any = sessionStorage.getItem('currentUser');
    this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(userToken));
    this.currentUser = this.currentUserSubject.asObservable();
    return this.currentUserSubject.value;
  }

  getProfileData() {
    return this.http.get<any>('profile');
  }

  login(userid: string, password: string) {
    return this.http.post<any>('/auth/login', { userid, password }).pipe(
      map((user) => {
        if (user && user.accessToken) {
          sessionStorage.setItem('currentUser', JSON.stringify(user));
          this.currentUserSubject.next(user);
        }

        return user;
      })
    );
  }

  logout() {
    const idToken = localStorage.getItem('idToken') as string;
    sessionStorage.clear();
    localStorage.clear();
    let loginType = environment.loginType;
    if (loginType != 'SSO') {
      this.router.navigate(['/login']);
    } else {
      if (environment.USE_LEGACY_PING_SSO) {
        window.location.href = environment.PING_SSO_URL;
      } else {
        window.location.href =
          environment.ENTRA_LOGOUT_SSO +
          `${encodeURIComponent(environment.ENTRA_LOGOUT_REDIRECT_SSO)}&id_token_hint=${encodeURIComponent(idToken)}`;
      }
    }
  }

  checkForIsNotMhvoucherSupportRole() {
    return !this.currentUserValue?.roles?.some((role: any) => role?.role_name === 'mhvoucher_support');
  }

  checkForOnlyMhvoucherSupportRole() {
    const userRoles = new Set(
      this.currentUserValue?.roles.map((item: Record<string, string>) => item.role_name.toLowerCase())
    );
    // return true if support role present with other roles too
    // return userRoles.has('mhvoucher_support') || userRoles.has('admin') ||  userRoles.has('mh_super');

    //retur true only user has support Role
    return userRoles.has('mhvoucher_support') && !userRoles.has('admin') && !userRoles.has('mhvoucher_superuser'); 
  }
}
